module.exports = __webpack_public_path__ + "img/pc-bg.35aa16c3.png";